import dayjs from "dayjs"
import { ScheduleMap } from "@/model/schedule"

/**
 * 清掃予定日ごとのマップから、本日分だけを抜き出す。
 *
 * 清掃予定日より前に開始・報告されてしまうのを防ぐため、
 * 一覧のデフォルトでは本日分だけを見せる。
 * 過去・未来を含む従来の一覧は「すべて」タブに残す。
 */
export const pickTodaySchedule = <Op>(
    schedule: ScheduleMap<Op>,
    now?: dayjs.ConfigType
): ScheduleMap<Op> => {
    const todayKey = dayjs(now).format("YYYYMMDD")
    const todayOperations = schedule[todayKey]

    return todayOperations ? { [todayKey]: todayOperations } : {}
}
